import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { initPopupData } from '../../../model/popup-data';
import { UtilitiesService } from '../../../services/utilities.service';
import { saveAs } from 'file-saver';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { DragDropFileDirective } from '../../../directives/drag-drop-file/drag-drop-file.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-fd-table-import-popup',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    DragDropFileDirective
  ],
  templateUrl: './fd-table-import-popup.component.html',
  styleUrl: './fd-table-import-popup.component.scss'
})
export class FdTableImportPopupComponent {
  popupdata = initPopupData;
  loading = false;
  resourceService;
  filename = ''

  constructor(
    public dialogRef: MatDialogRef<FdTableImportPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private utilities: UtilitiesService,
  ) {
    this.resourceService = data.resourceService
    this.filename = ''
  }

  downloadSampleCSV() {
    var tableName = this.data.resourceName;
    var formattedHeader = this.data.data;
    var header = Object.keys(formattedHeader).filter(x => x != undefined && ['select', 'selection', 'id'].indexOf(x.toLocaleLowerCase()) == -1 );
    let csv = [header.join(',')]
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' });
    saveAs(blob, (tableName ? tableName + '_' : '') + 'sample_import_file.csv');
  }

  import(event) {
    if (event?.target?.files?.[0] || event?.[0].file) {
      this.loading = true;
      var file: File
      if (event?.target?.files?.[0]) {
        file = event?.target?.files?.[0];
      }
      else if (event?.[0].file) {
        file = event?.[0].file;
      }
      this.filename = file.name;
      const formData = new FormData();
      formData.append('csv', file);
      this.resourceService.import(formData)
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.popupdata.title = "Success!";
              this.popupdata.content = res.message;
              this.popupdata.okayBtnText = "OK";
              this.popupdata.warn = false;
              this.dialogRef.close();
            }
            else {
              this.popupdata.title = "Failed";
              this.popupdata.content = "Failed to import " + this.data.resourceName + "  data. Please try again later."
              this.popupdata.warn = true;
            }
            this.utilities.showSnackbarAlert(this.popupdata);
            this.loading = false;
            event.target.value = null;
          },
          error: (err: any) => {
            console.log(err)
            this.popupdata.title = "Failed";
            this.popupdata.content = "Failed to import  " + this.data.resourceName + " data. Please try again later."
            this.popupdata.warn = true;
            this.utilities.showSnackbarAlert(this.popupdata);
            this.loading = false;
            event.target.value = null;
          }
        })
    }
  }
  cancel(): void {
    this.dialogRef.close();
  }
}
